import { useState } from 'react'
import { ReactSVG } from 'react-svg'

import { useAuth } from 'hooks/useAuth'
import { useLocalStorage } from 'hooks/useLocalStorage'
import { SocialProcessPopup } from 'components/common'
import { SocialScheme } from 'utils/constants'

export function SocialLoginButtons({ isModal }: { isModal?: boolean }) {
	const { setToken, setRefreshToken, setAuthInfo, setIsSignedUp } = useAuth()
	const [, setSocialLoginInformation] = useLocalStorage('socialLoginInformation', null)
	const [socialProvider, setSocialProvider] = useState<SocialScheme | null>(null)
	const isIG = navigator?.userAgent?.includes('Instagram')
	return (
		<div className="flex space-x-8 justify-center">
			{!isIG && import.meta.env.VITE_ENABLE_FEATURE_LOGIN_FACEBOOK === 'true' && (
				<button
					type="button"
					className="rounded-full text-center transition-all duration-300 bg-white shadow-button-social w-10 h-10 flex justify-center items-center"
					onClick={() => {
						setSocialProvider(SocialScheme.Facebook)
					}}
				>
					<span className="inline-block">
						<ReactSVG src="/images/auth/icon-facebook.svg" />
					</span>
				</button>
			)}

			{import.meta.env.VITE_ENABLE_FEATURE_LOGIN_APPLE === 'true' && (
				<button
					type="button"
					className="rounded-full text-center transition-all duration-300 bg-white shadow-button-social w-10 h-10 flex justify-center items-center"
					onClick={() => {
						setSocialProvider(SocialScheme.Apple)
					}}
				>
					<span className="inline-block">
						<ReactSVG src="/images/auth/icon-apple.svg" />
					</span>
				</button>
			)}

			{!isIG && import.meta.env.VITE_ENABLE_FEATURE_LOGIN_GOOGLE === 'true' && (
				<button
					type="button"
					className="rounded-full text-center transition-all duration-300 bg-white shadow-button-social w-10 h-10 flex justify-center items-center"
					onClick={() => {
						setSocialProvider(SocialScheme.Youtube)
					}}
				>
					<div className="text-[#DE4133]">
						<ReactSVG src="/images/auth/icon-google.svg" />
					</div>
				</button>
			)}
			<SocialProcessPopup
				action="sign-in"
				socialProvider={socialProvider}
				afterOpenPopup={() => setSocialProvider(null)}
				handleProcess={() => {
					const socialLoginInformation = JSON.parse(localStorage.getItem('socialLoginInformation') as string)
					if (socialLoginInformation) {
						const { token, refreshToken } = socialLoginInformation
						setToken(token)
						setRefreshToken(refreshToken)
						setAuthInfo(socialLoginInformation)
						setSocialLoginInformation(null)
					}

					setIsSignedUp(true)

					if (isModal) {
						window.location.reload()
					}
				}}
			/>
		</div>
	)
}
